import { useState, useRef, useEffect } from 'react';

export function useAskMeState() {
  const [showAI, setShowAI] = useState(false);
  const [showAIPopup, setShowAIPopup] = useState(false);
  const [showAskMe, setShowAskMe] = useState(false);
  const [showSmartLesson, setShowSmartLesson] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [askMeInput, setAskMeInput] = useState("");
  const [askMeLoading, setAskMeLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [askMeResult, setAskMeResult] = useState("");
  const [askMeMessages, setAskMeMessages] = useState([
    {
      id: 1,
      type: 'assistant',
      content: 'Hello! I am an AI assistant for creating exercises. How can I help you?',
      timestamp: new Date()
    }
  ]);
  const [askMeCurrentMessage, setAskMeCurrentMessage] = useState("");
  const askMeMessagesEndRef = useRef(null);
  const popupRef = useRef();

  useEffect(() => {
    askMeMessagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [askMeMessages]);

  useEffect(() => {
    if (!showAIPopup) return;
    const handleClick = e => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setShowAIPopup(false);
      }
    };
    document.addEventListener('mousedown', handleClick, true);
    return () => document.removeEventListener('mousedown', handleClick, true);
  }, [showAIPopup]);

  return {
    showAI, setShowAI,
    showAIPopup, setShowAIPopup,
    showAskMe, setShowAskMe,
    showSmartLesson, setShowSmartLesson,
    askMeInput, setAskMeInput,
    askMeLoading, setAskMeLoading,
    askMeResult, setAskMeResult,
    askMeMessages, setAskMeMessages,
    askMeCurrentMessage, setAskMeCurrentMessage,
    askMeMessagesEndRef,
    popupRef,
  };
}
